import { Token, WorkflowTokenType } from '@trlogic/ui-pack';
import { CaseReason, EscalatedReason } from './FlowDomains';

export interface WorkflowToken extends Token<WorkflowTokenType> {
  name: string;
  color: string;
  icon: string;
  status: boolean;
}

export interface PriorityToken extends WorkflowToken {}

export interface ConditionToken extends WorkflowToken {
  reason: CaseReason;
  score: number;
}

export interface ActionToken extends WorkflowToken {
  payload: {
    template: string;
  };
}

export interface ResolutionToken extends WorkflowToken {
  reason: CaseReason;
  score: number;
}

export interface FraudToken extends WorkflowToken {
  reason: CaseReason;
}

export interface NotFraudToken extends WorkflowToken {
  reason: CaseReason;
}

export interface SuspiciousToken extends WorkflowToken {
  reason: CaseReason;
}

export interface EscalatedToken extends WorkflowToken {
  reason: EscalatedReason;
}

export interface EventToken extends WorkflowToken {}

export interface StartToken extends WorkflowToken {}

export interface ResolutionJsonModel {
  reason: CaseReason | EscalatedReason;
  score: number;
  actions: any[];
  attachments: RuleAttachment[];
}

export interface RuleAttachment {
  name: string;
  expression: string;
}

export enum RuleTypes {
  MONITORING = 'monitoring',
  RESOLUTION = 'resolution',
}
